import type { Question } from "./schema";

// 質問の読み上げ文。ChatScreen の表示と、事前生成スクリプト
// (scripts/build-tts-assets.ts) の生成対象を同じ文字列に揃えるため共有する。
// ここが二重定義になると「生成した音声」と「実際に読み上げる文字列」がズレ、
// キャッシュが当たらず API 合成に落ちる。
export function questionText(q: Question): string {
  const suffix = q.type === "scale" ? `1 (${q.minLabel}) 〜 ${q.max} (${q.maxLabel})` : "";
  return suffix ? `${q.text} ${suffix} でお答えください。` : q.text;
}
